import React from "react";
import { StyleSheet, Text, View } from "react-native";
import Word from "./Word";
import _ from "lodash";

export default class SimpleSentence extends React.Component {

    render(){
        let customStyle = {};
        /*
        // NOTE: 统一在FixTextFontFamily.js里处理
        if (Platform.OS === "android") {
            // Fix Android 部分字体显示不全问题(如小米兰亭字体)
            // https://www.cnblogs.com/fresh-bright/p/13685644.html
            customStyle = {
                fontFamily: ""
            };
        }
        */

        let { style, ...props } = this.props;
        let { data } = this.props;
        return(
            data?
                data.words && _.isArray(data.words)?
                    <View style={[styles.container, this.props.style]}>
                        {data.words.map((item, i)=>{
                            //word的拼音不允许没有，根据字数，生成了拼音的数组，letter那pinyinVisible设置了不显示拼音
                            item.syllables = Array.from({ length: item.chars.length }, () => "");
                            return (
                                <Word
                                    key={i}
                                    data={item}
                                    style={[customStyle, style]}
                                    letterStyle={this.props.letterStyle}
                                    syllableStyle={this.props.syllableStyle}
                                    onPressing={this.props.onPressing}
                                    onPress={this.props.onWordPress}
                                    onLetterPress={this.props.onLetterPress}
                                    charVisible={this.props.charVisible}
                                    pinyinVisible={false}
                                    overriddenLetters={this.props.overriddenLetters}
                                />
                            )
                        })}
                    </View>
                :
                    <Text
                        allowFontScaling={true}
                        style={[customStyle, style]}
                    >
                        {data.chars ? data.chars.join("") : null}
                    </Text>
            :
                <Text
                    allowFontScaling={true}
                    style={[customStyle, style]}
                    {...props}
                >
                    {this.props.children}
                </Text>

        )
    }
}

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        flex:1,
    }
});
